import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Payment } from "../../../types/paymentTypes";

interface PaymentState {
  paymentsByBooking: Record<number, Payment[]>;
  loading: boolean;
  error: string | null;
}

const initialState: PaymentState = {
  paymentsByBooking: {},
  loading: false,
  error: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    endLoading(state) {
      state.loading = false;
    },
    setPaymentsForBooking(
      state,
      action: PayloadAction<{ bookingId: number; payments: Payment[] }>
    ) {
      state.paymentsByBooking[action.payload.bookingId] = action.payload.payments;
      state.loading = false;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const paymentActions = paymentSlice.actions;
export default paymentSlice;
